<button
  mat-mini-fab
  class="notification-button m-center"
  (click)="dropdown.toggle();"
>
  <mat-icon
    [matBadgeHidden]="(totalUnread$ | async) === 0"
    [matBadge]="totalUnread$ | async"
    class="large-icon pointer notifications-badge"
    color="primary"
    matBadgeColor="accent"
  >notifications</mat-icon>
</button>

<mojo-dropdown
  #dropdown
  (close)="markNotificationsAsRead()"
  [closeWhenClickedInside]="true"
>
  <mojo-notifications-container></mojo-notifications-container>
</mojo-dropdown>
